import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    open: false,
    content: '',
    data: null, // Add data field to hold additional data
};

const modalSlice = createSlice({
    name: 'modal',
    initialState,
    reducers: {
        openModal: (state, action) => {
            state.open = true;
            state.content = action.payload.content;
            state.data = action.payload.data || null; // Set data if provided
        },
        closeModal: state => {
            state.open = false;
            state.content = '';
            state.data = null; // Reset data when closing
        },
    },
});

export const { openModal, closeModal } = modalSlice.actions;
export default modalSlice.reducer;
